import { render, staticRenderFns } from "./ManualsModal.vue?vue&type=template&id=26ffe043&"
import script from "./ManualsModal.vue?vue&type=script&lang=js&"
export * from "./ManualsModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports